// src/pages/UserRoutes.jsx
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import RouteModal from "../components/RouteModal";
import CreateSurveyModal from "../components/CreateSurveyModal";
import SurveysModal from "../components/SurveysModal";
import api from "../utils/api";
import { useAuth } from "../context/AuthContext";

const Page = styled.div`
  min-height: 100vh;
  padding: 20px;
  background: linear-gradient(135deg, #fff7ed, #fff9f2);
`;

const Title = styled.h2`
  margin-bottom: 12px;
  color: #1f2937;
  font-size: 24px;
  font-weight: 700;
`;

const AddBtn = styled.button`
  background: linear-gradient(90deg, #ff7a2a, #ffb06b);
  color: #fff;
  padding: 8px 12px;
  border-radius: 10px;
  border: none;
  font-weight: 700;
  cursor: pointer;
  margin-bottom: 12px;
  &:hover {
    opacity: 0.9;
  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: #fffdf9;
  border-radius: 10px;
  overflow: hidden;
`;

const Th = styled.th`
  background: #ffedd5;
  padding: 12px;
  text-align: left;
`;

const Td = styled.td`
  padding: 12px;
  border-bottom: 1px solid #f5f5f5;
  vertical-align: middle;
`;

const ActionBtn = styled.button`
  background: ${(props) => props.bg || "#ff0000"};
  color: #fff;
  padding: 6px 10px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  &:hover {
    opacity: 0.85;
  }
`;

const UserRoutes = () => {
  const [routes, setRoutes] = useState([]);
  const [users, setUsers] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSurveyModalOpen, setIsSurveyModalOpen] = useState(false);
  const [isSurveysViewModalOpen, setIsSurveysViewModalOpen] = useState(false);
  const [selectedRouteId, setSelectedRouteId] = useState(null);
  const { token } = useAuth();

  useEffect(() => {
    fetchRoutes();
    fetchUsers();
  }, []);

  const fetchRoutes = async () => {
    try {
      const res = await api.get("/api/dataanalysis/routes", {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = res.data?.routes || res.data?.data || res.data || [];
      setRoutes(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Error fetching routes:", err);
    }
  };

  const fetchUsers = async () => {
    try {
      const res = await api.get("/api/dataanalysis/surveyors", {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = res.data?.users || res.data?.data || res.data || [];
      setUsers(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Error fetching users:", err);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this route?")) return;
    try {
      await api.delete(`/api/dataanalysis/routes/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchRoutes();
    } catch (err) {
      console.error("Delete failed:", err);
    }
  };

  const handleModalSave = () => {
    setIsModalOpen(false);
    fetchRoutes();
  };

  const handleCreateSurvey = (routeId) => {
    setSelectedRouteId(routeId);
    setIsSurveyModalOpen(true);
  };

  const handleSurveyModalSave = () => {
    setIsSurveyModalOpen(false);
    setSelectedRouteId(null);
    fetchRoutes();
  };

  const handleRouteRowClick = (routeId) => {
    setSelectedRouteId(routeId);
    setIsSurveysViewModalOpen(true);
  };

  const handleSurveysModalClose = () => {
    setIsSurveysViewModalOpen(false);
    setSelectedRouteId(null);
  };

  return (
    <Page>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "12px",
        }}
      >
        <Title>Select Route</Title>
      </div>

      <Table>
        <thead>
          <tr>
            <Th>Name</Th>
            <Th>Total Surveys</Th>
            <Th>Start Location</Th>
            <Th>End Location</Th>
          </tr>
        </thead>
        <tbody>
          {routes.length === 0 ? (
            <tr>
              <Td colSpan="5" style={{ textAlign: "center", padding: "20px" }}>
                No routes found.
              </Td>
            </tr>
          ) : (
            routes.map((r) => (
              <tr
                key={r._id}
                onClick={() => handleRouteRowClick(r._id)}
                style={{ cursor: "pointer" }}
              >
                <Td>{r.name}</Td>
                <Td>{r.surveyIds.length}</Td>
                <Td>
                  {r.startLocation?.latitude?.toFixed(4)},{" "}
                  {r.startLocation?.longitude?.toFixed(4)}
                </Td>
                <Td>
                  {r.endLocation?.latitude?.toFixed(4)},{" "}
                  {r.endLocation?.longitude?.toFixed(4)}
                </Td>
              </tr>
            ))
          )}
        </tbody>
      </Table>

      {isSurveysViewModalOpen && (
        <SurveysModal
          isOpen={isSurveysViewModalOpen}
          onClose={handleSurveysModalClose}
          routeId={selectedRouteId}
          selectable={true}
        />
      )}
    </Page>
  );
};

export default UserRoutes;
